import { FaLeaf, FaStar, FaTruck } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* Footer Top Section */}
        <div className="footer-top">
          <div className="footer-feature">
            <div className="feature-icon">
              <FaLeaf />
            </div>
            <div className="feature-text">
              <h4>१००% ताजा</h4>
              <p>सिधै खेतबाट ताजा उत्पादन</p>
            </div>
          </div>

          <div className="footer-feature">
            <div className="feature-icon">
              <FaTruck />
            </div>
            <div className="feature-text">
              <h4>मुफ्त वितरण</h4>
              <p>₹५००० भन्दा माथि मुफ्त वितरण</p>
            </div>
          </div>

          <div className="footer-feature">
            <div className="feature-icon">
              <FaStar />
            </div>
            <div className="feature-text">
              <h4>गुणस्तरीय</h4>
              <p>उत्कृष्ट गुणस्तरको सब्जीहरू</p>
            </div>
          </div>
        </div>






      </div>
    </footer>
  );
};

export default Footer;